/**
 * Message bundle registry.
 *
 * v0 ships only `en-US`. SHT language-access policy (operational
 * dependency) names additional priority languages for v1 launch;
 * their bundles land here as parallel files under their BCP-47
 * tags. Adding a locale: import the bundle + add it to the
 * registry export.
 */
import { enUSBundle } from './en-US.js';
export const DEFAULT_LOCALE = 'en-US';
export const BUNDLE_REGISTRY = {
    'en-US': enUSBundle,
};
//# sourceMappingURL=index.js.map